<div class="start-sales">

  <div class="start-sales__toolbar">
    <div class="start-sales__search">
      <i class="fa fa-search"></i>
      <input type="text"
             class="start-sales__search-input"
             placeholder="Поиск по ЖК, застройщику, датам"
             [ngModel]="global_search_string"
             (ngModelChange)="onGlobalSearch($event)">
      @if (global_search_string) {
        <i class="fa fa-times start-sales__search-clear" title="Очистить" (click)="onGlobalSearch('')"></i>
      }
    </div>

    <div class="start-sales__filters">
      <app-material-input-checkbox [(ngModel)]="on_showcase" [cssClass]="'mb-0'" [border]="true" [withMb0]="true">
        Активен
      </app-material-input-checkbox>

      <div title="В архиве">
        <app-material-input-checkbox [(ngModel)]="is_archive" [cssClass]="'mb-0'" [border]="true" [withMb0]="true">
          <i class="fa fa-trash-o"></i>
        </app-material-input-checkbox>
      </div>

      <a [href]="urlExcel" class="button button_sm" target="_blank" title="Скачать список участников">
        <i class="fa fa-download"></i>
      </a>

      <button type="button" class="button button_sm" (click)="createStartSales()">
        Создать<span class="d-none d-md-inline"> старт продаж</span>
      </button>
    </div>
  </div>

  <div class="start-sales__status">
    <span class="start-sales__count">Всего: {{count}}</span>
    @if (order_saving) {
      <span class="start-sales__saving"><i class="fa fa-refresh fa-spin"></i> Сохраняем порядок</span>
    }
  </div>

  <div class="start-sales__list" [class.is-loading]="loading">

    @for (row of rows; track row.start_of_sales_id; let i = $index) {
      <div class="ss-card"
           [class.ss-card_dragging]="drag_index === i"
           [class.ss-card_archive]="row.is_archive"
           [class.ss-card_editing]="editing_end_id === row.start_of_sales_id"
           [draggable]="drag_enabled"
           (dragstart)="onDragStart($event, i)"
           (dragover)="onDragOver($event, i)"
           (drop)="onDrop($event)"
           (dragend)="onDragEnd()">

        @if (!is_archive) {
          <span class="ss-card__handle"
                title="Перетащить"
                (mousedown)="enableDrag()"
                (touchstart)="enableDrag()">
            <i class="fa fa-bars"></i>
          </span>
        }

        <div class="ss-card__order">
          @if (!is_archive) {
            <span class="ss-card__step">
              <i class="fa fa-angle-double-up" title="В самый верх"
                 [class.is-disabled]="isFirstOverall(i)" (click)="moveToTop(row)"></i>
              <i class="fa fa-angle-up" title="Выше" [class.is-disabled]="i === 0" (click)="moveBy(i, -1)"></i>
              <i class="fa fa-angle-down" title="Ниже" [class.is-disabled]="i === rows.length - 1" (click)="moveBy(i, 1)"></i>
              <i class="fa fa-angle-double-down" title="В самый низ"
                 [class.is-disabled]="isLastOverall(i)" (click)="moveToBottom(row)"></i>
            </span>
          }
        </div>

        <div class="ss-card__photo">
          @if (row.complex_render_url) {
            <img [src]="row.complex_render_url" [alt]="row.complex_caption">
          } @else {
            <span class="ss-card__photo-empty"><i class="fa fa-building-o"></i></span>
          }
        </div>

        <div class="ss-card__body">
          <div class="ss-card__title">
            @if (row.complex_id) {
              <a [routerLink]="['/housing2/complex/', row.complex_id]" [title]="row.complex_caption">{{row.complex_caption}}</a>
            } @else {
              <span [title]="row.complex_caption">{{row.complex_caption}}</span>
            }
          </div>
          <div class="ss-card__developer" [title]="row.developer_caption">{{row.developer_caption}}</div>

          <div class="ss-card__meta">
            <div class="ss-card__meta-item ss-card__meta-item_start">
              <span class="ss-card__label">Начало</span>
              <span class="ss-card__value">{{row.date_start || '—'}}</span>
            </div>
            <div class="ss-card__meta-item ss-card__meta-item_end">
              <span class="ss-card__label">Окончание</span>
              @if (editing_end_id === row.start_of_sales_id) {
                <div class="ss-end-editor" (click)="$event.stopPropagation()">
                  <div class="ss-end-editor__tabs">
                    <button type="button" class="ss-end-editor__tab"
                            [class.is-active]="editing_end_when_publish"
                            (click)="setEditEndMode(true)">
                      До публикации
                    </button>
                    <button type="button" class="ss-end-editor__tab"
                            [class.is-active]="!editing_end_when_publish"
                            (click)="setEditEndMode(false)">
                      Дата
                    </button>
                  </div>
                  @if (!editing_end_when_publish) {
                    <div class="ss-end-editor__date">
                      <app-material-input-datepicker [formControl]="editing_end_date_control"
                        [placeholder]="'Дата окончания'">
                      </app-material-input-datepicker>
                    </div>
                  }
                  <span class="ss-end-editor__actions">
                    <i class="fa fa-check" title="Сохранить" [class.is-disabled]="end_saving" (click)="saveEditEnd(row)"></i>
                    <i class="fa fa-times" title="Отменить" [class.is-disabled]="end_saving" (click)="cancelEditEnd()"></i>
                  </span>
                </div>
              } @else {
                @if (row.is_archive) {
                  <span class="ss-card__value">
                    {{row.end_when_publish ? 'До публикации на витрине' : (row.date_end || '—')}}
                  </span>
                } @else {
                  <span class="ss-card__value ss-card__editable" title="Изменить дату окончания" (click)="startEditEnd(row)">
                    {{row.end_when_publish ? 'До публикации на витрине' : (row.date_end || 'Указать дату')}}
                  </span>
                }
              }
            </div>
            <div class="ss-card__meta-item ss-card__meta-item_members">
              <span class="ss-card__label">Записей</span>
              <span class="ss-card__value">
                @if (row.members_count) {
                  <a href="javascript: void(0)" (click)="participantsStartSales(row)">{{row.members_count}}</a>
                } @else {
                  <span class="ss-card__muted">Нет</span>
                }
              </span>
            </div>
            <div class="ss-card__meta-item ss-card__meta-item_author">
              <span class="ss-card__label">Автор</span>
              <span class="ss-card__value">
                @if (row.author_id) {
                  <a [routerLink]="['/physical/edit/', row.author_id]" [title]="row.author_fio">{{row.author_fio}}</a>
                } @else {
                  <span class="ss-card__muted">—</span>
                }
              </span>
            </div>
            <div class="ss-card__meta-item ss-card__meta-item_created">
              <span class="ss-card__label">Создан</span>
              <span class="ss-card__value ss-card__muted">{{row.create_time}}</span>
            </div>
          </div>
        </div>

        <div class="ss-card__actions">
          <div class="button button_icon" title="Редактировать" (click)="editStartSales(row)">
            <i class="fa fa-pencil"></i>
          </div>
          @if (!row.is_archive) {
            <div class="button button_icon" title="В архив" (click)="deleteStartSales(row.start_of_sales_id)">
              <i class="fa fa-trash"></i>
            </div>
          }
        </div>
      </div>
    } @empty {
      @if (!loading) {
        <div class="start-sales__empty">
          @if (global_search_string) {
            Ничего не нашлось. Измените запрос или сбросьте поиск.
          } @else {
            Стартов продаж пока нет. Создайте первый.
          }
        </div>
      }
    }
  </div>

  @if (pages.length > 1) {
    <div class="start-sales__pagination">
      <button type="button" class="page-btn" [disabled]="current_page === 1" (click)="changePage(current_page - 1)">
        <i class="fa fa-angle-left"></i>
      </button>
      @for (page of pages; track page) {
        <button type="button" class="page-btn" [class.is-active]="page === current_page" (click)="changePage(page)">
          {{page}}
        </button>
      }
      <button type="button" class="page-btn" [disabled]="current_page === pages.length" (click)="changePage(current_page + 1)">
        <i class="fa fa-angle-right"></i>
      </button>
    </div>
  }
</div>
